module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-control field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Images")]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "is-pulled-left"
  }, [_vm._l((_vm.selectedImages), function(image) {
    return _c('div', {
      staticClass: "selected-image is-128x128-max is-pulled-left"
    }, [(!_vm.selecting) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'image',
          params: {
            id: image.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.thumbnail_path
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.selecting) ? _c('img', {
      attrs: {
        "src": image.thumbnail_path
      }
    }) : _vm._e(), _vm._v(" "), (_vm.selecting) ? _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.removeImage(image)
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "images-control is-pulled-left"
  }, [(!_vm.selecting) ? _c('div', [(_vm.selectedImages.length === 0) ? _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.selecting = true
      }
    }
  }, [_vm._v("Add images")])]) : _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.selecting = true
      }
    }
  }, [_vm._v("Edit images")])])]) : _vm._e()])], 2)]), _vm._v(" "), (_vm.selecting) ? _c('div', [_c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save Selection")]), _vm._v("\n         \n        "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.selecting = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Select your image(s):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgSearch),
      expression: "imgSearch"
    }],
    staticClass: "input is-inline",
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": (_vm.imgSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "grow"
    }
  }, [(_vm.selecting) ? _c('div', {
    staticClass: "image-list"
  }, _vm._l((_vm.filteredImages), function(img) {
    return (_vm.selectedImages.indexOf(img) === -1) ? _c('div', {
      staticClass: "image-tile",
      on: {
        "click": function($event) {
          return _vm.selectImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "level",
      staticStyle: {
        "height": "50px"
      }
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('div', {
      staticClass: "level-item"
    }, [_c('img', {
      staticStyle: {
        "max-width": "50px"
      },
      attrs: {
        "src": img.thumbnail_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "level-item image-description"
    }, [_vm._v("\n                            " + _vm._s(img.name) + "." + _vm._s(img.extension) + "\n                        ")])])])]) : _vm._e()
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218ed994"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/ImageableControl.vue
// module id = 511
// module chunks = 0